const icons = require.context('../../images/icons', true)

export const icon = (file) => icons(`./${file}`, true)

export const achIcon = icons('./ach.png', true)
export const addressIcon = icons('./address.png', true)
export const amenitiesIcon = icons('./amenities.png', true)
export const autoPayIcon = icons('./autopay.png', true)
export const avatarIcon = icons('./avatar.png', true)
export const avatarAltIcon = icons('./avatar_alt.png', true)
export const avatarListIcon = icons('./avatar_list.png', true)
export const calendarIcon = icons('./calendar.png', true)
export const chatIcon = icons('./chat.png', true)
export const chatAltIcon = icons('./chat_alt.png', true)
export const classesIcon = icons('./classes.png', true)
export const contactsIcon = icons('./contacts.png', true)
export const creditCardIcon = icons('./credit_card.png', true)
export const datingIcon = icons('./dating.png', true)
export const darkPackagesIcon = icons('./dark_packages.png', true)
export const docSigningIcon = icons('./doc_signing.png', true)
export const eventsIcon = icons('./events.png', true)
export const failureIcon = icons('./failure.png', true)
export const guestsIcon = icons('./guests.png', true)
export const leasesIcon = icons('./leases.png', true)
export const linksIcon = icons('./links.png', true)
export const documentsIcon = icons('./documents.png', true)
export const loadingIcon = icons('./loading.gif', true)
export const maintenanceIcon = icons('./maintenance.png', true)
export const marketplaceIcon = icons('./marketplace.png', true)
export const neighborsIcon = icons('./neighbors.png', true)
export const neighborsAltIcon = icons('./neighbors_alt.png', true)
export const noResultsIcon = icons('./no_results.png', true)
export const packagesIcon = icons('./packages.png', true)
export const parkingIcon = icons('./parking.png', true)
export const paymentIcon = icons('./payment.png', true)
export const petsIcon = icons('./pets.png', true)
export const phoneIcon = icons('./phone.png', true)
export const socialIcon = icons('./social.png', true)
export const specialOffersIcon = icons('./special_offers.png', true)
export const storageIcon = icons('./storage.png', true)
export const successIcon = icons('./success.png', true)
export const supportIcon = icons('./storage.png', true)
export const surveysIcon = icons('./surveys.png', true)
export const targetIcon = icons('./target.png', true)
export const walletIcon = icons('./wallet.png', true)
export const warningIcon = icons('./warning.png', true)
export const whitelabelAvatarIcon = icons('./avatar_blank.png', true)
export const whitelabelFailureIcon = icons('./whitelabel_failure.png', true)
export const whitelabelPaymentIcon = icons('./whitelabel_payment.png', true)
export const whitelabelSuccessIcon = icons('./whitelabel_success.png', true)
export const whitelabelWarningIcon = icons('./whitelabel_warning.png', true)
